module.exports = [
	"xanthan",
	"xanthate",
	"xanthates",
	"xanthein",
	"xanthene",
	"xanthian",
	"xanthic",
	"xanthin",
	"xanthine",
	"xanthium",
	"xanthoma",
	"xanthomas",
	"xanthomata",
	"xanthopsia",
	"xanthous",
	"xanthoxyl",
	"xebec",
	"xebecs",
	"xenarthral",
	"xenia",
	"xenial",
	"xenium",
	"xenobiotic",
	"xenocryst",
	"xenocrysts",
	"xenogamy",
	"xenogenous",
	"xenograft",
	"xenografts",
	"xenolith",
	"xenoliths",
	"xenomania",
	"xenon",
	"xenophile",
	"xenophiles",
	"xenophobe",
	"xenophobes",
	"xenophobia",
	"xenophoby",
	"xenophya",
	"xenotime",
	"xerafin",
	"xerafins",
	"xeransis",
	"xerantic",
	"xerarch",
	"xerasia",
	"xeric",
	"xeroderma",
	"xerodermia",
	"xerodermic",
	"xerography",
	"xeroma",
	"xeromas",
	"xeromata",
	"xeromorph",
	"xeromorphs",
	"xerophagy",
	"xerophily",
	"xerophyte",
	"xerophytes",
	"xerophytic",
	"xerosis",
	"xerostoma",
	"xerostomia",
	"xerotes",
	"xerotic",
	"xi",
	"xiphoid",
	"xiphoidal",
	"xiphopagic",
	"xiphopagus",
	"xiphosuran",
	"xoana",
	"xoanon",
	"xu",
	"xylem",
	"xylene",
	"xylenes",
	"xylenol",
	"xylenols",
	"xylic",
	"xylitol",
	"xylocarp",
	"xylocarps",
	"xylogen",
	"xylogenous",
	"xylograph",
	"xylographs",
	"xylography",
	"xyloid",
	"xyloidin",
	"xylol",
	"xylology",
	"xylols",
	"xyloma",
	"xylomas",
	"xylometer",
	"xylometers",
	"xylonic",
	"xylophagan",
	"xylophage",
	"xylophages",
	"xylophone",
	"xylophones",
	"xylophonic",
	"xylorimba",
	"xylorimbas",
	"xylose",
	"xylotomous",
	"xylyl",
	"xylyls",
	"xyst",
	"xyster",
	"xysters",
	"xysti",
	"xystoi",
	"xystos",
	"xysts",
	"xystus"
];


//////////////////
// WEBPACK FOOTER
// ./src/data/words-x.json
// module id = 975
// module chunks = 1